import AppForm from '../app-components/Form/AppForm';

Vue.component('dynamic-fields-form', {
    mixins: [AppForm],

    props: {
        'data': {
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
    },

    data: function() {
        return {
            form: {},
            defaultForm: {
                scope: 1,
                type:  1,
                options: [],
                company_id: null
            }
        }
    },

    created: function() {
        if (!_.isEmpty(this.data) && this.data.id) {
            this.form = this.data;
        } else{
            this.form = Object.assign({}, this.defaultForm);
        }

        this.form.options = (this.data.options ? this.data.options : []);
        this.form.company_id = this.data.company_id;
    },

    methods: {
        goBack()
        {
            window.location.href = '/dynamic-fields';
        },

        optionSave(continueAdding)
        {
            if($("#dynamicFieldOptionInput").val() != "")
            {
                this.form.options.push($("#dynamicFieldOptionInput").val());
                $("#dynamicFieldOptionInput").val("");
            }
            if(continueAdding)
            {
                $("#dynamicFieldOptionInput").focus();
            }
        },

        optionDiscard()
        {
            $("#dynamicFieldOptionInput").val("");
        },

        optionDelete(idx)
        {
            this.$delete(this.form.options, idx);
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/dynamic-fields/Form.js